import { withStyleDeep } from 'styletron-react';
import EntryRow from './EntryRow';

// TODO: Fix in future styletron updates where type inference works correctly.
// Replaced styletron's withStyle implementation as we get this error when using these components:
// JSX element type 'HighlightedEntryRow' does not have any construct or call signatures. ts(2604)
const HighlightedEntryRow = withStyleDeep(EntryRow, {
  borderTopWidth: '1px',
  borderTopcolor: '#007c94',
  borderTopStyle: 'dashed',
  borderBottomWidth: '1px',
  borderBottomcolor: '#007c94',
  borderBottomStyle: 'dashed'
});

export default HighlightedEntryRow;
